import React, { FunctionComponent } from 'react';

import { features } from 'components/lexemes';

import { FeatureCtaContainer } from 'containers/common/app/feature-cta-container';
import { FaqContainer } from 'containers/common/components/faq/faq-container';
import { VideoChatBlockOneContainer } from 'containers/features/video-chat/video-chat-block-one-container';
import { VideoChatBlockThreeContainer } from 'containers/features/video-chat/video-chat-block-three-container';
import { VideoChatBlockTwoContainer } from 'containers/features/video-chat/video-chat-block-two-container';
import { VideoChatHeroBlockContainer } from 'containers/features/video-chat/video-chat-hero-block-container';
import { PageContainer } from 'containers/page/page-container';
import { FooterContainer } from 'containers/project-love/common/app/footer-container';
import { HeaderContainer } from 'containers/project-love/common/app/header-container';

const faqContent = () => [
  {
    question: features.audioCalls.lxAudioCallsFaqQuestionOneTitle,
    answer: features.audioCalls.lxAudioCallsFaqQuestionOneAnswer,
  },
  {
    question: features.audioCalls.lxAudioCallsFaqQuestionTwoTitle,
    answer: features.audioCalls.lxAudioCallsFaqQuestionTwoAnswer,
  },
  {
    question: features.audioCalls.lxAudioCallsFaqQuestionThreeTitle,
    answer: features.audioCalls.lxAudioCallsFaqQuestionThreeAnswer,
  },
];

export const VideoChatContainer: FunctionComponent = () => {
  return (
    <PageContainer>
      <HeaderContainer />
      <main id="main" tabIndex={-1}>
        <VideoChatHeroBlockContainer />
        <VideoChatBlockOneContainer />
        <VideoChatBlockTwoContainer />
        <VideoChatBlockThreeContainer />
        <FaqContainer title={features.audioCalls.lxFeaturesFaqTitle} content={faqContent()} />
        <FeatureCtaContainer title={features.audioCalls.lxAudioCallsCta} />
      </main>
      <FooterContainer />
    </PageContainer>
  );
};
